import { render, staticRenderFns } from "./TeacherCreate.vue?vue&type=template&id=3426a414&"
import script from "./TeacherCreate.js?vue&type=script&lang=js&"
export * from "./TeacherCreate.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports